<aran-sidebar
  [menuItems]="[
     {
      role: true,
      link: routeMetaData.myAccount.link,
      icon: routeMetaData.myAccount.icon,
      title: routeMetaData.myAccount.title,
    },
    {
      role: true,
      link: routeMetaData.requests.link,
      icon: routeMetaData.requests.icon,
      title: routeMetaData.requests.title,
    },
    {
      role: true,
      link: routeMetaData.accessAndUse.link,
      icon: routeMetaData.accessAndUse.icon,
      title: routeMetaData.accessAndUse.title
    },
  ]"
  [userDetail]="fullName"
  [appVersion]="'Version: ' + version"
  [appName]="appInfo.appName"
  [isTestMode]="isTestMode"
  [showUserInitials]="true"
  [logoutText]="'Log Out'"
  (onHandleLogOut)="logout()"
></aran-sidebar>

<aran-loading></aran-loading>
